import {
    observable,
    action,
    computed,
    runInAction,
    reaction,
    decorate
} from 'mobx';

import WebApi from '../../../WebApi';

import { LimitsApi } from './api';
import CommonStore from "../../../CommonStore";
import {number} from "@amcharts/amcharts4/core";
import {id} from "date-fns/locale";

class LimitsStore extends CommonStore {
  rootStore: RootStoreInterface;
  apiClient: WebApi;

  createError: AxiosError | undefined;
  constructor(rootStore: RootStoreInterface) {
      const apiClient = new LimitsApi(rootStore.apiClient);
      super(rootStore, apiClient);
      this.rootStore = rootStore;
      this.specification = rootStore.specifications["Limits"];

  }

  async createLimit(id: number, data) {
      console.log('createLimit! -->', id, data)
    try {
      runInAction(() => {
        this.createError = undefined;
        this.isAddingInProgress = true;
      });
      const res = await this.apiClient.createLimit(id, data);
      runInAction(() => {
        this.isAddingInProgress = false;
      });
      return res;
    } catch (err) {
      this.captureError(err);
      this.isAddingInProgress = false;
      this.createError = err;
    }
  }


}


decorate(LimitsStore, {
    createLimit: action,
    getLimit: action,
});

export default LimitsStore;
